//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { CalculationSetting } from "./calculation-setting";

export class CurrentDatasourceColumnValue extends CalculationSetting {
    static readonly areaCodeContextKey: string = "AreaCodeContextKey";
    static readonly tableNameContextKey: string = "TableNameContextKey";
    columnName?: string;
}
